import { Megaphone } from 'lucide-react'
import { sdk } from '@/lib/sdk'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const Call4PapersPage = lazyPage(() => import('@/pages/Call4Papers'), 'Call4PapersPage')
const CallDetailsPage = lazyPage(() => import('@/pages/CallDetails'), 'CallDetailsPage')

export const call4papersModule: ModuleDefinition = {
  key: 'call4papers',
  icon: Megaphone,
  iconName: 'megaphone',
  namespaces: ['call4papers'],
  ready: true,
  ListPage: Call4PapersPage,
  /* The space resolves the call's slug: the API looks the call up inside it,
     not across the whole community. */
  renderDetail: ({ spaceData }) => <CallDetailsPage spaceId={spaceData.id} />,
  singleItem: {
    modeKey: 'spaceMode',
    isEmpty: async (spaceId) => {
      const config = await sdk.call4papers.getSpace(spaceId) as { mode?: string; call?: { id?: string } | null } | null
      return config?.mode === 'single' && !config.call?.id
    }
  },
  workflow: { trigger: { block: 'proposals', families: ['proposal'] } }
}
